'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import '@dynamic-labs/utils';
import '../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../components/Alert/Alert.js';
import '../../events/dynamicEvents.js';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../utils/constants/colors.js';
import '../../utils/constants/values.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useDynamicContext/useInternalDynamicContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../../store/state/nonce/nonce.js';
import '../../store/state/projectSettings/projectSettings.js';
import '../../config/ApiEndpoint.js';
import '../../store/state/user/user.js';
import '../../locale/locale.js';
import '../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../store/state/primaryWalletId/primaryWalletId.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../context/AccountExistsContext/AccountExistsContext.js';
import '../../context/UserWalletsContext/UserWalletsContext.js';
import '../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../utils/functions/compareChains/compareChains.js';
import '../../context/ThemeContext/ThemeContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import '@dynamic-labs/types';
import '../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../context/LoadingContext/LoadingContext.js';
import '../../context/WalletContext/WalletContext.js';
import '../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../context/MockContext/MockContext.js';
import '../CollectUserDataView/useFields.js';
import '../../context/FieldsStateContext/FieldsStateContext.js';
import '../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../store/state/loadingAndLifecycle.js';
import '../../store/state/walletOptions/walletOptions.js';
import { Typography } from '../../components/Typography/Typography.js';
import '../../context/FooterAnimationContext/index.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../context/WalletGroupContext/WalletGroupContext.js';
import '../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'react-focus-lock';
import { Divider } from '../../components/Divider/Divider.js';
import '../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../components/IconButton/IconButton.js';
import '../../components/MenuList/Dropdown/Dropdown.js';
import { useSubdomainCheck } from '../../utils/hooks/useSubdomainCheck/useSubdomainCheck.js';
import '../../store/state/sendBalances.js';
import { Input } from '../../components/Input/Input.js';
import '../../components/OverlayCard/OverlayCard.js';
import '../TransactionConfirmationView/TransactionConfirmationView.js';
import '../../context/PasskeyContext/PasskeyContext.js';
import '../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../context/OnrampContext/OnrampContext.js';
import 'qrcode';
import '../../widgets/DynamicWidget/views/ReceiveExternalWalletFunds/ReceiveExternalWalletFunds.js';
import '../../../index.js';
import '../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../context/ConnectWithOtpContext/constants.js';
import '../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../store/state/tokenBalances.js';
import '../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import { useDebounce } from '../../utils/hooks/useDebounce/useDebounce.js';
import '../../components/InlineWidget/InlineWidget.js';
import '../../components/IsBrowser/IsBrowser.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';

const SubdomainField = ({ showDetails = false, }) => {
    const { t } = useTranslation();
    const { values, setFieldValue, initialValues } = useFormikContext();
    const checkSubdomain = useSubdomainCheck();
    const { projectSettings } = useInternalDynamicContext();
    const [checkResponse, setCheckResponse] = useState(undefined);
    // When the subdomain is saved, the value is stored in a metadata object
    // instead, so we need to default to the initial value to prevent the
    // value from disappearing
    const subDomainValue = useMemo(() => values['name-service-subdomain-handle'] === undefined
        ? initialValues['name-service-subdomain-handle'] || ''
        : values['name-service-subdomain-handle'], [values, initialValues]);
    const ensDomain = useMemo(() => {
        var _a;
        const domain = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.nameService) === null || _a === void 0 ? void 0 : _a.evm.domain;
        if (!domain) {
            return undefined;
        }
        return `.${domain}`;
    }, [projectSettings]);
    const runCheckSubdomain = useCallback((value) => __awaiter(void 0, void 0, void 0, function* () {
        if (value !== '' &&
            value !== initialValues['name-service-subdomain-handle']) {
            const checkReponse = yield checkSubdomain({
                subdomain: value,
            });
            setCheckResponse(checkReponse);
        }
        else {
            setCheckResponse(undefined);
        }
    }), [checkSubdomain, initialValues]);
    const debouncedCheckSubdomain = useDebounce(runCheckSubdomain, 500);
    const onChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setFieldValue('name-service-subdomain-handle', e.target.value);
        debouncedCheckSubdomain(e.target.value);
    });
    const message = useMemo(() => {
        if (!checkResponse) {
            return undefined;
        }
        if (checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.error) {
            return t('dyn_subdomain_field.error');
        }
        if (!(checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available)) {
            return t('dyn_subdomain_field.not_available');
        }
        return t('dyn_subdomain_field.available');
    }, [checkResponse, t]);
    if (!ensDomain) {
        logger.error('Failed to get ENS domain from settings.sdk.nameService');
        return null;
    }
    return (jsxs(Fragment, { children: [jsxs("div", { className: 'subdomain-field__container', children: [jsx(Input, { id: 'subdomain-field', className: 'input__container--available', value: subDomainValue, onChange: onChange, label: t('dyn_subdomain_field.label'), error: message && !(checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available) ? true : false, success: checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available, message: message }), jsx(Typography, { as: 'span', color: 'secondary', variant: 'body_normal', children: ensDomain })] }), showDetails && (jsx(Typography, { as: 'p', color: 'secondary', variant: 'body_small', className: 'subdomain-field__details', children: t('dyn_subdomain_field.details') })), jsx(Divider, {})] }));
};

export { SubdomainField };
